import {handleRequest} from './base';

const BusinessRepo = {
  all: () => {
    return handleRequest({
      method: 'get',
      url: '/api/business'
    })
  },

  fetch: (bizID) => {
    return handleRequest({
      method: 'get',
      url: '/api/business/' + bizID,
    })
  },

  create: (data) => {
    return handleRequest({
      method: 'post',
      url: '/api/business',
      data: data,
    })
  },

  update: (business, data) => {
    return handleRequest({
      method: 'put',
      url: `/api/business/${business.id}`,
      data: data,
    })
  },
};

export default BusinessRepo;